import { createReducer } from '@reduxjs/toolkit'

import {
  attachNotes,
  attachNotesFailure,
  attachNotesSuccess,
  attachTranscript,
  attachTranscriptFailure,
  attachTranscriptSuccess,
  detachNotes,
  detachNotesFailure,
  detachNotesSuccess,
  detachTranscript,
  detachTranscriptFailure,
  detachTranscriptSuccess,
  startDiscoveryRun,
  startDiscoveryRunFailure,
  startDiscoveryRunSuccess,
} from './actions'
import { IDiscoveryRunsState } from './types'

// Purely transient in-flight flags — the sourcing DATA lives on the campaign
// (state.campaigns), refreshed via the existing fetchCampaignSuccess action
// once a mutation's full-brief-view response comes back. Failure actions
// only reset the flag; error text goes to the user via toast (nothing reads
// stored error state — review fix pruned the dead fields/selectors).
const initialState: IDiscoveryRunsState = {
  attachingTranscript: false,
  attachingNotes: false,
  starting: false,
  detachingTranscript: false,
  detachingNotes: false,
}

const discoveryRunsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(attachTranscript, (state) => {
      state.attachingTranscript = true
    })
    .addCase(attachTranscriptSuccess, (state) => {
      state.attachingTranscript = false
    })
    .addCase(attachTranscriptFailure, (state) => {
      state.attachingTranscript = false
    })
    .addCase(attachNotes, (state) => {
      state.attachingNotes = true
    })
    .addCase(attachNotesSuccess, (state) => {
      state.attachingNotes = false
    })
    .addCase(attachNotesFailure, (state) => {
      state.attachingNotes = false
    })
    .addCase(detachTranscript, (state) => {
      state.detachingTranscript = true
    })
    .addCase(detachTranscriptSuccess, (state) => {
      state.detachingTranscript = false
    })
    .addCase(detachTranscriptFailure, (state) => {
      state.detachingTranscript = false
    })
    .addCase(detachNotes, (state) => {
      state.detachingNotes = true
    })
    .addCase(detachNotesSuccess, (state) => {
      state.detachingNotes = false
    })
    .addCase(detachNotesFailure, (state) => {
      state.detachingNotes = false
    })
    .addCase(startDiscoveryRun, (state) => {
      state.starting = true
    })
    .addCase(startDiscoveryRunSuccess, (state) => {
      state.starting = false
    })
    .addCase(startDiscoveryRunFailure, (state) => {
      state.starting = false
    })
})

export default discoveryRunsReducer
